import { dataTagPrefix } from './constants';

export const extractDataFromTag = (key: string): string => {
  if (!document)
    throw new Error(
      'Extracting data from tag is only expected to run on the client'
    );
  const tag = document.getElementById(`${dataTagPrefix}${key}`);
  if (!tag || !tag.textContent)
    throw new Error(`Expected to find a non-empty data tag for key ${key}`);
  return tag.textContent;
};
